import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: "https://3813b727e5bd1d2caa7f457dbed82bc7@o4509744521740288.ingest.us.sentry.io/4511251315163136",
  sendDefaultPii: true
});

import App from './App.tsx'
import './styles/globals.css'
import { createRoot } from 'react-dom/client'
// Initialize token refresh interceptors
import '@/services/tokenRefresh.service'

createRoot(document.getElementById('root')!).render(
    <App />
)